// extracted by mini-css-extract-plugin
module.exports = {"addressesWrapper":"Addresses_addressesWrapper__DOnSn"};